import { render } from "./company_pending.html?vue&type=template&id=39567720&external"
import script from "./company_pending.js?vue&type=script&lang=js&external"
export * from "./company_pending.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__